/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React from 'react';
import FilterCategory from './FilterCategory';

const FiltersPanel = ({ selectedFilters, removeFilter }) => {
  const validFilters = Object.entries(selectedFilters || {}).reduce((acc, [category, filters]) => {
    if (Array.isArray(filters) && filters.length > 0) {
      acc[category] = filters;
    }
    return acc;
  }, {});

  const hasActiveFilters = Object.keys(validFilters).length > 0;

  return (
    <div className="filters-container for-filter">
      {/* <h5 className="filters-title self-my-2">Active Filters</h5> */}
      {/* <div className="filters-content my-for-fliter"> */}
      <div className="row self-mb-10">
        {hasActiveFilters ? (
          Object.entries(validFilters).map(([category, filters]) => (
            <div className='col-md-2'>
              <FilterCategory
                key={category}
                title={category}
                filters={filters}
                removeFilter={removeFilter}
              />
            </div>
          ))
        ) : (
          <p className='text-center'>No filters selected.</p>
        )}
      </div>
    </div>
  );
};

export default FiltersPanel;
